exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3at36USP1QBRr2FDEivsxH{width:236px}", ""]);
// Exports
exports.locals = {
	"categoriesMenuContainer": "_3at36USP1QBRr2FDEivsxH"
};